// extracted by mini-css-extract-plugin
module.exports = {"buttonMargin":"style-module--buttonMargin--883GN","loader":"style-module--loader--QMr-N"};